"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const formik_1 = require("formik");
const Modal_1 = __importDefault(require("@/components/Modal"));
const Input_1 = __importDefault(require("@/components/Input"));
const Button_1 = __importDefault(require("@/components/Button"));
const style_1 = require("./style");
const AutocompleteField_1 = __importDefault(require("@/components/AutocompleteField"));
function SystemFormView({ isOpen, onClose, values, onChange, onSubmit, errors, isLoading, onBlur, formTitle, touched, confirmActionText, options, setFieldValue, }) {
    const onChangeAutoComplete = (event, value, reason) => {
        if (reason === "clear") {
            setFieldValue("site", { value: "", label: "" });
            return;
        }
        setFieldValue("site", value);
    };
    return (react_1.default.createElement(Modal_1.default, { title: formTitle, isOpen: isOpen, onClose: onClose },
        react_1.default.createElement(formik_1.Form, null,
            react_1.default.createElement(style_1.FormSection, null,
                react_1.default.createElement(style_1.StyledFormControl, null,
                    react_1.default.createElement(Input_1.default, { name: "name", id: "name", onBlur: onBlur, error: Boolean(errors["name"] && touched["name"]), helperText: touched["name"] ? errors["name"] : "", onChange: onChange, label: "Name", disabled: isLoading, value: values.name, required: true })),
                react_1.default.createElement(style_1.StyledFormControl, null,
                    react_1.default.createElement(AutocompleteField_1.default, { name: "site", error: Boolean(errors["site"] && touched["site"]), helperText: touched["site"] ? errors["site"]?.label : "", label: "Site", getOptionLabel: (option) => option.label, options: options, isOptionEqualToValue: (option, value) => {
                            return option?.label === value?.label;
                        }, disabled: isLoading, id: "site", onChange: onChangeAutoComplete, value: values.site, required: true })),
                react_1.default.createElement(style_1.FormActions, null,
                    react_1.default.createElement(Button_1.default, { label: "Cancel", disabled: isLoading, onClick: onClose, size: "medium", variant: "outlined", color: "secondary" }),
                    react_1.default.createElement(Button_1.default, { label: confirmActionText, onClick: onSubmit, isLoading: isLoading, disabled: isLoading, size: "medium", color: "primary", variant: "contained" }))))));
}
exports.default = SystemFormView;
